import React, {memo, useEffect, useState} from "../../../__snowpack__/pkg/react.js";
import {Progress, Descriptions, Modal} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {CheckCircleOutlined, CloseCircleOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {useRequest} from "../../../__snowpack__/pkg/ahooks.js";
import {request} from "../../utils/request/index.js";
export var E_TASK_STATUS;
(function(E_TASK_STATUS2) {
  E_TASK_STATUS2["INIT"] = "INIT";
  E_TASK_STATUS2["PROCESSING"] = "PROCESSING";
  E_TASK_STATUS2["COMPLETE"] = "COMPLETE";
  E_TASK_STATUS2["SOCKET_ERROR"] = "SOCKET_ERROR";
})(E_TASK_STATUS || (E_TASK_STATUS = {}));
export var E_COMPLETE_STATUS;
(function(E_COMPLETE_STATUS2) {
  E_COMPLETE_STATUS2["INIT"] = "INIT";
  E_COMPLETE_STATUS2["SUCCESS"] = "SUCCESS";
  E_COMPLETE_STATUS2["FAILURE"] = "FAILURE";
})(E_COMPLETE_STATUS || (E_COMPLETE_STATUS = {}));
let initStatus = {
  status: "INITIAL",
  successNum: 0,
  failNum: 0,
  total: 0,
  percent: 0
};
export const PollingTaskResult = memo(({
  taskId,
  formatMessage,
  onComplete = () => {
  },
  setTaskId
}) => {
  const {data, run, cancel} = useRequest((taskId2) => request.get(`/saas/product-v2/task/get-task-result?taskId=${taskId2}`), {
    pollingInterval: 3e3,
    pollingErrorRetryCount: 3
  });
  const [taskInfo, setTaskInfo] = useState(initStatus);
  useEffect(() => {
    taskId && run(taskId);
  }, [taskId]);
  useEffect(() => {
    if (data) {
      setTaskInfo(data);
      if (["FINISHED", "FAILED"].includes(data.status)) {
        cancel();
      }
    }
  }, [data]);
  const [messageList, setMessageList] = useState([]);
  return /* @__PURE__ */ React.createElement(Modal, {
    forceRender: true,
    width: 490,
    title: formatMessage({id: "globalTaskResult"}),
    visible: !!taskId,
    onOk: () => {
      onComplete();
      setTaskId(null);
    },
    closable: taskInfo.status !== "FINISHED",
    onCancel: () => {
      onComplete();
      setTaskId(null);
    }
  }, /* @__PURE__ */ React.createElement(ModalWrapper, null, taskInfo.status === "FAILED" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CloseCircleOutlined, {
    width: 16,
    height: 16,
    style: {marginRight: 8, color: "#E7192C"}
  }), formatMessage({id: "theSystemServiceIsAbnormalPlease"})) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, taskInfo.status === "INITIAL" || taskInfo.status === "IN_PROCESS" ? /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "globalTaskWait"})) : taskInfo.status === "FINISHED" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CheckCircleOutlined, {
    width: 16,
    height: 16,
    style: {marginRight: 8, color: "#66BE75"}
  }), formatMessage({id: "globalTaskSuccess"})) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CloseCircleOutlined, {
    width: 16,
    height: 16,
    style: {marginRight: 8, color: "#E7192C"}
  }), formatMessage({id: "globalTaskFailed"}))), /* @__PURE__ */ React.createElement("p", null, taskInfo.status !== "INITIAL" ? `${formatMessage({id: "total"})}: ${taskInfo.total}` : null), /* @__PURE__ */ React.createElement(Progress, {
    showInfo: false,
    strokeColor: {
      "0%": "#B699FF",
      "100%": "#4C04FF"
    },
    status: taskInfo.status !== "FINISHED" ? "active" : "normal",
    percent: (taskInfo.successNum + taskInfo.failNum) / taskInfo.total * 100
  }), taskInfo.status === "FINISHED" ? /* @__PURE__ */ React.createElement(Descriptions, {
    bordered: true
  }, /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: formatMessage({id: "globalTaskTotalNumber"}),
    span: 3
  }, /* @__PURE__ */ React.createElement("span", {
    className: "count"
  }, taskInfo.total)), /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: formatMessage({id: "globalTaskSuccessNumber"}),
    span: 3
  }, /* @__PURE__ */ React.createElement("span", {
    className: "count",
    style: {color: "#66BE75"}
  }, taskInfo.successNum)), /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: formatMessage({id: "globalTaskFailedNumber"}),
    span: 3
  }, /* @__PURE__ */ React.createElement("span", {
    className: "count",
    style: {color: "#E7192C"}
  }, taskInfo.failNum))) : null)));
});
const ModalWrapper = styled.div`
  p {
    font-size: 14px;
    font-family: SFProText-Medium, SFProText;
    font-weight: 500;
    color: #202d40;
    line-height: 20px;
    margin-bottom: 13px;
  }
  span {
    font-size: 12px;
    font-weight: 400;
    color: #202d40;
    line-height: 22px;
  }
  .ant-progress-inner {
    margin-bottom: 12px;
    height: 17px;
    .ant-progress-bg {
      height: 17px !important;
    }
  }
  .count {
    font-size: 13px;
    font-family: SFProText-Medium, SFProText;
    font-weight: 500;
    color: #202d40;
    line-height: 20px;
  }
  .tips {
    display: flex;
    align-items: center;
  }
`;
